"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _flex = _interopRequireDefault(require("../../styles-common/flex"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _input = _interopRequireDefault(require("../../styles-common/input"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _const = require("./const");

var _style = require("./style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Typography = function Typography(_ref) {
  var theme = _ref.theme,
      setTheme = _ref.setTheme;
  var font = theme.font,
      titleSize = theme.titleSize,
      captionSize = theme.captionSize,
      axisTitleSize = theme.axisTitleSize;

  var selectedFont = _const.FONTS.find(function (f) {
    return f.value === font;
  }) || _const.FONTS[0];

  var handleChangeFont = function handleChangeFont(option) {
    setTheme(_objectSpread({}, theme, {
      font: option.value
    }));
  };

  var handleChangeSize = function handleChangeSize(key, value) {
    var reg = new RegExp('^[0-9]*$');
    var setValue = value !== '' && reg.test(Number(value)) ? value : 'auto';
    setTheme(_objectSpread({}, theme, _defineProperty({}, key, setValue)));
  };

  return _react["default"].createElement("div", null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "options-title"
  }, "Font"), _react["default"].createElement(_reactSelect["default"], {
    value: selectedFont,
    onChange: handleChangeFont,
    options: _const.FONTS,
    styles: _style.InputStyles
  }), _react["default"].createElement("br", null), _react["default"].createElement(_flex["default"], {
    row: true
  }, _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "typography-title-size"
  }, "Title size"), _react["default"].createElement(_input["default"], {
    name: "typography-title-size",
    value: titleSize === "auto" ? '' : titleSize,
    type: "text",
    onChange: function onChange(e) {
      return handleChangeSize('titleSize', e.target.value);
    },
    placeholder: "Auto"
  })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlF: true,
    or: "typography-caption-size"
  }, "Caption size"), _react["default"].createElement(_input["default"], {
    name: "typography-caption-size",
    value: captionSize === "auto" ? '' : captionSize,
    type: "text",
    onChange: function onChange(e) {
      return handleChangeSize('captionSize', e.target.value);
    },
    placeholder: "Auto"
  })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
    htmlFor: "typography-axisTitleSize"
  }, "Axis title size"), _react["default"].createElement(_input["default"], {
    name: "typography-axisTitleSize",
    value: axisTitleSize === "auto" ? '' : axisTitleSize,
    type: "text",
    onChange: function onChange(e) {
      return handleChangeSize('axisTitleSize', e.target.value);
    },
    placeholder: "Auto"
  }))));
};

var _default = Typography;
exports["default"] = _default;